if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span') || this.submitButton.querySelector('p.t2');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const productVariantId = formData.get('id');

        // Check if we need to add an additional product and wait for it to complete
        this.checkAndAddAdditionalProduct(formData)
          .then(() => {
            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;

            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Fallback: try to open cart-drawer directly instead of going to /cart page
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: productVariantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    // Сбрасываем флаг — в quick-add-modal ветке он иначе остаётся навсегда
                    const cartDrawerItemsEl = document.querySelector('cart-drawer-items');
                    if (cartDrawerItemsEl) cartDrawerItemsEl.isAddingAdditionalProduct = false;

                    // Ensure response has required data before rendering
                    if (this.cart && response) {
                      if (response.sections && Object.keys(response.sections).length > 0) {
                        // Has sections - render directly
                        this.cart.renderContents(response);
                      } else if (response.item_count !== undefined || response.total_price !== undefined) {
                        // Has cart data but no sections - trigger fetch via cart-drawer-items
                        const cartDrawerItems = document.querySelector('cart-drawer-items');
                        if (cartDrawerItems) {
                          cartDrawerItems.onCartUpdate({ cartData: response });
                        } else {
                          // Fallback: try to render anyway
                          this.cart.renderContents(response);
                        }
                      } else {
                        // No useful data - trigger full update
                        const cartDrawerItems = document.querySelector('cart-drawer-items');
                        if (cartDrawerItems) {
                          cartDrawerItems.onCartUpdate();
                        }
                      }
                    }
                  }, 100);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart && response && (response.sections || response.item_count !== undefined)) {
                this.cart.renderContents(response);
              }

              // Reset the isAddingAdditionalProduct flag after a delay to ensure it's not stuck
              setTimeout(() => {
                const cartDrawerItems = document.querySelector('cart-drawer-items');
                if (cartDrawerItems && cartDrawerItems.isAddingAdditionalProduct) {
                  cartDrawerItems.isAddingAdditionalProduct = false;
                }
              }, 500);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      /**
       * Проактивное добавление упаковки в тот же запрос при добавлении товара
       * Использует PackagingUtils для определения нужных упаковок
       */
      async checkAndAddAdditionalProduct(formData) {
        if (!window.PackagingUtils) return;

        const config = window.PackagingUtils.getConfig();
        if (!config) return;

        const productType = this.dataset.productType || '';
        const requiresShipping = this.dataset.requiresShipping !== 'false';

        let cart = null;
        try {
          cart = await window.PackagingUtils.fetchFullCart();
        } catch (_) {
          cart = { items: [] };
        }

        const packagingIds = window.PackagingUtils.getPackagingItemsForAdd(
          cart, config.frozenId, config.cooledId, productType, requiresShipping
        );

        if (packagingIds.length > 0) {
          // Конвертируем FormData в items[] формат
          const mainProductId = formData.get('id');
          const mainProductQuantity = formData.get('quantity') || 1;

          formData.delete('id');
          formData.delete('quantity');
          formData.append('items[0][id]', mainProductId);
          formData.append('items[0][quantity]', mainProductQuantity);

          packagingIds.forEach((id, index) => {
            formData.append(`items[${index + 1}][id]`, id);
            formData.append(`items[${index + 1}][quantity]`, 1);
          });

          // Ставим флаг, чтобы cart-drawer не запускал повторную проверку
          const cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems) {
            cartDrawerItems.isAddingAdditionalProduct = true;
          }
        }
      }
    }
  );
}
